import React, { useCallback } from "react";

import { useParams } from "react-router-dom";

import useHiddenChat from "@app/util/useHiddenChat";

import ActivityAnnotation from "../../component/activity/ActivityAnnotation";

interface Props {}

const EditActivityPage: React.FC<Props> = () => {
  const { aid } = useParams<{ aid: string }>();
  const handleHide = useCallback(() => {
    window.parent.postMessage("closeCreateEditActivityModal", "*");
  }, []);

  useHiddenChat();

  return <ActivityAnnotation activityId={parseInt(aid, 10)} onHide={handleHide} />;
};

export default EditActivityPage;
